<template>
    <div class="">
        <button-primary @click="showCreate = true">Create group</button-primary>

        <portal to="modal" v-if="showCreate">
            <modal @close="showCreate = false">

                <label class="mt-4">
                    Name:
                    <input v-model="name">
                </label>

                <label class="mt-4">
                    Code:
                    <input v-model="code">
                </label>

                <button class="mt-4" @click="create">Erstellen</button>
            </modal>
        </portal>
    </div>
</template>

<script>
    import Modal from "../Modal";
    import ButtonPrimary from '../UI/ButtonPrimary.vue';
    export default {
        name: "CreateGroup",
        components: {Modal,ButtonPrimary},
        data:() => ({
            showCreate: false,
            name: '',
            code: '',
        }), 

        methods: {
            create() {
                window.axios
                    .post('/super/groups', {
                        name: this.name,
                        code: this.code,
                    })
                    .then(function (response) {
                        location.reload();
                    })
                    .catch(error => {
                        this.$root.$emit('error', error);
                    });
            }
        }
    }
</script>

<style scoped>

</style>
